var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useStyleSheet, useThemeContext } from '../../../hooks';
import { createStyleSheet } from '../../../utils';
import { Base } from './Base';
export const Primary = (_a) => {
    var { style } = _a, props = __rest(_a, ["style"]);
    const styles = useStyleSheet(getStyles);
    const { color } = useThemeContext();
    const iconColor = {
        default: color.white.p100,
        negative: color.white.p100,
        white: color.black.p100
    };
    const iconHoverColor = {
        default: color.white.p100,
        negative: color.white.p100,
        white: color.black.p100
    };
    return (React.createElement(Base, Object.assign({ wrapperStyle: style, style: [styles.container, styles[`container__${props.accent}`]], hoverStyle: styles[`container__${props.accent}__hover`], textStyle: styles[`text__${props.accent}`], textHoverStyle: styles[`text__${props.accent}__hover`], iconColor: iconColor[props.accent], iconHoverColor: iconHoverColor[props.accent] }, props)));
};
const getStyles = createStyleSheet(({ color }) => ({
    container: {},
    container__default: {
        backgroundColor: color.primary.solid
    },
    container__negative: {
        backgroundColor: color.negative.solid
    },
    container__white: {
        backgroundColor: color.white.p100
    },
    container__default__hover: {
        backgroundColor: color.primary.solidHover
    },
    container__negative__hover: {
        backgroundColor: color.negative.solidHover
    },
    container__white__hover: {
        backgroundColor: color.white.p84
    },
    text__default: {
        color: color.white.p100
    },
    text__negative: {
        color: color.white.p100
    },
    text__white: {
        color: color.black.p100
    },
    text__default__hover: {
        color: color.white.p100
    },
    text__negative__hover: {
        color: color.white.p100
    },
    text__white__hover: {
        color: color.black.p100
    }
}));
//# sourceMappingURL=Primary.js.map